<template>
    <div>
        <div class="col-12 text-right mb-2 pl-0">
            <div class="position-relative">
                <b-button ref="AddPopUpForm" id="AddPopUpForm" @click="ShowPopUpForm('Entity');show = !show" text="Add" class="btn custom-button">
                    Add Entity
                </b-button>
            </div><svg v-b-tooltip class="d-none"></svg>
        </div>
        <div class="col-md-12">
            <template>
                <div class="common-table">
                    <b-table :items="EntityData.rows"
                                :fields="entityFields"
                                id="all-items"
                                show-empty
                                striped
                                hover
                                responsive
                                class="all-items entity-table">
                            <template #cell(IsTimeOnly)="data">
                                {{ data.item.IsTimeOnly ? 'Yes' : 'No' }}
                            </template>
                        <template #cell(toggle)="row">
                            <a class="expand-collapse-button" @click="row.toggleDetails">{{ row.detailsShowing ? '-' : '+' }}</a>
                        </template>
                        <template #row-details="row">
                            <b-table :items="getAgencies(row.item.ID)"
                                        :fields="agencyFields"
                                        :no-local-sorting="true"
                                        show-empty
                                        striped
                                        hover
                                        responsive
                                        class="all-items agencies-table">
                                <template #cell(toggle)="subRow">
                                    <a class="expand-collapse-button" @click="subRow.toggleDetails">{{ subRow.detailsShowing ? '-' : '+' }}</a>
                                </template>
                                <template #row-details="agencyRow">
                                    <b-table :items="getAccountingOffices(agencyRow.item.Id)"
                                                :fields="accountingFields"
                                                :no-local-sorting="true"
                                                show-empty
                                                striped
                                                hover
                                                responsive
                                                class="all-items accounting-Office-table">
                                        <template #cell(toggle)="accRow">
                                            <a class="expand-collapse-button" @click="accRow.toggleDetails">{{ accRow.detailsShowing ? '-' : '+' }}</a>
                                        </template>
                                        <template #row-details="accRow">
                                            <b-table :items="getMediaOffices(accRow.item.Id)"
                                                        :fields="mediaFields"
                                                        :no-local-sorting="true"
                                                        show-empty
                                                        striped
                                                        hover
                                                        responsive
                                                        class="all-items media-Office-table">
                                                <template #cell(isExcludeFromReporting)="data">
                                                    {{ data.item.isExcludeFromReporting ? 'Yes' : 'No' }}
                                                </template>
                                                <template #cell(action)="mediaRow">
                                                    <div class="icon-container ml-2" v-b-tooltip.hover.v-dark.top.html="'Edit Media Office'">
                                                        <a class="" @click="EditMediaOffice(mediaRow.item)" ><b-img class="edit-icon" :src="editIcon"/> </a>
                                                    </div>
                                                </template>
                                            </b-table>
                                        </template>
                                        <template #cell(action)="accRow">
                                            <div class="d-flex">
                                                <div class="icon-container" v-b-tooltip.hover.v-dark.top.html="'Add Media Office'">
                                                    <a class="add-button" @click="ShowPopUpForm('MediaOffice', accRow.item.Id)"><b-img :src="addIcon" /></a>
                                                </div>
                                                <div class="icon-container ml-2" v-b-tooltip.hover.v-dark.top.html="'Edit Accounting Office'">
                                                    <a class="" @click="EditAccountingOffice(accRow.item)" ><b-img class="edit-icon" :src="editIcon"/> </a>
                                                </div>
                                            </div>
                                        </template>
                                    </b-table>
                                </template>
                                <template #cell(action)="subRow">
                                    <div class="d-flex">
                                        <div class="icon-container" v-b-tooltip.hover.v-dark.top.html="'Add Accounting Office'">
                                            <a class="add-button" @click="ShowPopUpForm('AccountingOffice', subRow.item.Id)"><b-img :src="addIcon" /></a>
                                        </div>
                                        <div class="icon-container ml-2" v-b-tooltip.hover.v-dark.top.html="'Edit Agency'">
                                            <a class="" @click="EditAgency(subRow.item)" ><b-img class="edit-icon" :src="editIcon"/> </a>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </template>
                        <template #cell(action)="row">
                            <div class="d-flex">
                                <div class="icon-container" v-b-tooltip.hover.v-dark.top.html="'Add Agency'">
                                    <a class="add-button" @click="ShowPopUpForm('Agency', row.item.ID)"><b-img :src="addIcon" /></a>
                                </div>
                                <div class="icon-container ml-2" v-b-tooltip.hover.v-dark.top.html="'Edit Entity'">
                                    <a class="" @click="EditEntity(row.item)" ><b-img class="edit-icon" :src="editIcon"/> </a>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>
            </template>
        </div>
        <b-modal v-model="ShowEntityForm" hide-footer hide-header :no-close-on-backdrop="true">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-3">
                    <h5 class="modal-title mb-2">{{this.IsEdit ? 'Edit Entity' : 'Add Entity'}}</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
                <div class="col-10 mx-auto">
                    <div class="mb-1">
                        <label>Entity Code</label>
                        <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '####']" class="form-control" id="EntityCode" v-model="EntityRequest.code" placeholder="Enter Entity Code"></the-mask>
                    </div>
                    <div class="mb-1">
                        <label>Entity Name</label>
                        <b-form-input v-model="EntityRequest.name" placeholder="Enter Entity Name" id="EntityName"></b-form-input>
                    </div>
                    <div class="mb-1">
                        <b-form-checkbox v-model="EntityRequest.isTimeOnly" :value="true" label="" inline>Time Only</b-form-checkbox>
                    </div>
                    <div class="text-right my-4">
                        <button class="btn btn-link text-uppercase" @click="HidePopUpForm()">Cancel</button>
                        <button v-if="this.IsEdit" :disabled="!IsEntityFormValid" class="text-uppercase btn btn-primary" @click="UpdateEntityForm()">Update</button>
                        <button v-else :disabled="!IsEntityFormValid" class="text-uppercase btn btn-primary" @click="SubmitEntityForm()">Submit</button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="ShowAgencyForm" hide-footer hide-header :no-close-on-backdrop="true">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-3">
                    <h5 class="modal-title mb-2">{{this.IsEdit ? 'Edit Agency' : 'Add Agency'}}</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
                <div class="col-10 mx-auto">
                    <div class="mb-1">
                        <label>Entity</label>
                        <OmniSelect class="" placeholder="Select Entity" name="Entity" :showLabel="false" :disabled="IsEdit || AgencyRequest.EntityId !== null" label="value" v-model="AgencyRequest.EntityId" :options="EntitiesForAgency" ></OmniSelect>
                    </div>
                    <div class="mb-1">
                        <label>Agency Name</label>
                        <b-form-input v-model="AgencyRequest.Name" placeholder="Enter Agency Name" id="EntityName" :maxlength="50" @blur="CheckAgencyNameExist()" v-bind:class="{
                            errorborder: IsAgencyNameExist,
                            noterrorborder: !IsAgencyNameExist,
                            }"></b-form-input>
                        <p v-if="IsAgencyNameExist" class="error-message-format">
                            This Agency Name already exists. Please proceed with an alternate one.
                        </p>
                    </div>
                   <div class="mb-1">
                        <label>MDM Guid</label>
                        <b-form-input v-model="AgencyRequest.MDMGuid" placeholder="Enter MDM Guid" id="MDMGuid" required
                            :class="{ 'errorborder': AgencyRequest.MDMGuid && !IsMDMGuidValid }"></b-form-input>
                        <p v-if="AgencyRequest.MDMGuid && !IsMDMGuidValid" class="error-message-format">
                            MDM Guid is required and must be alphanumeric.
                        </p>
                    </div>
                    <div class="text-right my-4">
                        <button class="btn btn-link text-uppercase" @click="HidePopUpForm()">Cancel</button>
                        <button v-if="this.IsEdit" :disabled="!IsAgencyFormValid || IsAgencyNameExist" class="text-uppercase btn btn-primary" @click="UpdateAgencyForm()">Update</button>
                        <button v-else :disabled="!IsAgencyFormValid || IsAgencyNameExist" class="text-uppercase btn btn-primary" @click="SubmitAgencyForm()">Submit</button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="ShowAccountingOfficeForm" hide-footer hide-header :no-close-on-backdrop="true">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-3">
                    <h5 class="modal-title mb-2">{{this.IsEdit ? 'Edit Accounting Office' : 'Add Accounting Office'}}</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
                <div class="col-10 mx-auto">
                    <div class="mb-1">
                        <label>Agency</label>
                        <OmniSelect class="" placeholder="Select Agency" name="Agency" :showLabel="false" :disabled="IsEdit || AccountingOfficeRequest.AgencyId !== null" label="value" v-model="AccountingOfficeRequest.AgencyId" :options="AgenciesForAccountingOffice"></OmniSelect>
                    </div>
                    <div class="mb-1">
                        <label>Accounting Office Code</label>
                        <b-form-input
                            v-model="AccountingOfficeRequest.Code"
                            placeholder="Enter Accounting Office Code"
                            id="AccountingOfficeCode"
                            :maxlength="2">
                        </b-form-input>
                    </div>
                    <div class="mb-1">
                        <label>Accounting Office Name</label>
                        <b-form-input v-model="AccountingOfficeRequest.Name" :maxlength="50" placeholder="Enter Accounting Office Name" id="AccOfficeName"></b-form-input>
                    </div>
                    <div class="mb-1">
                        <label>Prisma NG Location ID</label>
                        <b-form-input v-model="AccountingOfficeRequest.PrismaNGLocationId" :maxlength="3" placeholder="Enter Prisma NG Location ID" id="PrismaNGLocationID"></b-form-input>
                    </div>
                    <div class="mb-1">
                        <label>Prisma NG Location Name</label>
                        <b-form-input v-model="AccountingOfficeRequest.PrismaNGLocationName" :maxlength="200" placeholder="Enter Prisma NG Location Name" id="PrismaNGLocationName"></b-form-input>
                    </div>
                    <div class="mb-1">
                        <label>AX / D365 Location</label>
                        <b-form-input v-model="AccountingOfficeRequest.AXD365Location" :maxlength="8" placeholder="Enter AX / D365 Location" id="AXD365Location"></b-form-input>
                    </div>
                    <div class="mb-1">
                        <label>SMI Cube</label>
                        <OmniSelect class="" placeholder="Select SMI Cube" name="SMICube" :showSearch="false" :showLabel="false" label="value" v-model="AccountingOfficeRequest.SMICube" :options="SMICubeList" ></OmniSelect>
                    </div>
                    <div class="text-right my-4">
                        <button class="btn btn-link text-uppercase" @click="HidePopUpForm()">Cancel</button>
                        <button v-if="this.IsEdit" :disabled="!IsAccountingOfficeFormValid" class="text-uppercase btn btn-primary" @click="UpdateAccountingOfficeForm()">Update</button>
                        <button v-else :disabled="!IsAccountingOfficeFormValid" class="text-uppercase btn btn-primary" @click="SubmitAccountingOfficeForm()">Submit</button>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal v-model="ShowMediaOfficeForm" hide-footer hide-header :no-close-on-backdrop="true">
            <div class="row">
                <div class="col-12 d-flex justify-content-between border-bottom mb-3">
                    <h5 class="modal-title mb-2">{{this.IsEdit ? 'Edit Media Office' : 'Add Media Office'}}</h5>
                    <button class="close" @click="HidePopUpForm()"></button>
                </div>
                <div class="col-10 mx-auto">
                    <div class="mb-1">
                        <label>Accounting Office</label>
                        <OmniSelect class="" placeholder="Select Accounting Office" name="AccountingOffice" :showLabel="false" :disabled="IsEdit  || MediaOfficeRequest.AccountingOfficeId !== null" label="value" v-model="MediaOfficeRequest.AccountingOfficeId" :options="AccountingOfficeForMediaOffice"></OmniSelect>
                    </div>
                    <div class="mb-1">
                        <label>Media Office Code</label>
                        <b-form-input v-model="MediaOfficeRequest.Code" placeholder="Enter Media Office Code" id="MediaOfficeCode" :maxlength="3" @blur="CheckMediaOfficeCodeExist()" v-bind:class="{
                            errorborder: IsMediaOfficeCodeExist,
                            noterrorborder: !IsMediaOfficeCodeExist,
                            }"></b-form-input>
                        <p v-if="IsMediaOfficeCodeExist" class="error-message-format">
                            This Media Office Code already exists. Please proceed with an alternate one.
                        </p>
                    </div>
                    <div class="mb-1">
                        <label>Media Office Name</label>
                        <b-form-input v-model="MediaOfficeRequest.Name" :maxlength="50" placeholder="Enter Media Office Name" id="MediaOfficeName"></b-form-input>
                    </div>
                    <div class="mb-1">
                        <label>SMI Cube</label>
                        <OmniSelect class="" placeholder="Select SMI Cube" name="SMICube" :showSearch="false" :showLabel="false" label="value" v-model="MediaOfficeRequest.SMICube" :options="SMICubeList" ></OmniSelect>
                    </div>
                    <div class="mb-1 mt-3">
                        <b-form-checkbox v-model="MediaOfficeRequest.IsExcludeFromReporting">Exclude from Reporting</b-form-checkbox>
                    </div>
                    <div class="text-right my-4">
                        <button class="btn btn-link text-uppercase" @click="HidePopUpForm()">Cancel</button>
                        <button v-if="this.IsEdit" :disabled="!IsMediaOfficeFormValid || IsMediaOfficeCodeExist" class="text-uppercase btn btn-primary" @click="UpdateMediaOfficeForm()">Update</button>
                        <button v-else :disabled="!IsMediaOfficeFormValid || IsMediaOfficeCodeExist" class="text-uppercase btn btn-primary" @click="SubmitMediaOfficeForm()">Submit</button>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import tabtable from "../../mixins/tabtable";
import { mapGetters } from 'vuex';
import store from "@/store";
import { TheMask } from 'vue-the-mask'
export default {
    name: "EntityManagement",
    mixins: [tabtable],
    components: {
        TheMask
    },
    data() {
        return {
            IsEdit: false,
            AllEntities: [],
            IsAgencyNameExist: false,
            IsMediaOfficeCodeExist: false,
            EntityId : null,
            EntityData: {
                rows: [],
            },
            AgencyList: [],
            AccountingOfficeList: [],
            MediaOfficeList: [],
            EntitiesForAgency: [],
            AgenciesForAccountingOffice: [],
            AccountingOfficeForMediaOffice: [],
            show: false,
            SMICubeList: [
                { value: 'US', label: 'US' },
                { value: 'Pan Regional LATAM', label: 'Pan Regional LATAM' },
                { value: 'Exclude', label: 'Exclude' },
            ],
            ShowEntityForm: false,
            ShowAgencyForm: false,
            ShowAccountingOfficeForm: false,
            ShowMediaOfficeForm: false,
            entityFields: [
                { key: 'toggle', label: '', class: 'text-center', tdClass: 'align-middle' },
                { key: 'Code', label: 'Entity Code' },
                { key: 'Name', label: 'Entity Name' },
                { key: 'IsTimeOnly', label: 'Time Only' },
                { key: 'action', label: 'Action' },
            ],
            agencyFields: [
                { key: 'toggle', label: '', class: 'text-center', tdClass: 'align-middle' },
                { key: 'agency', label: 'Agency' },
                { key: 'mdmGuid', label: 'MDM Guid' },
                { key: 'action', label: 'Action' },
            ],
            accountingFields: [
                { key: 'toggle', label: '', class: 'text-center', tdClass: 'align-middle' },
                { key: 'accountingOffice', label: 'Accounting Office' },
                { key: 'prismaNGLocationId', label: 'Prisma NG Location ID' },
                { key: 'prismaNGLocationName', label: 'Prisma NG Location Name' },
                { key: 'axD365Location', label: 'AX / D365 Location' },
                { key: 'smiCube', label: 'SMI Cube' },
                { key: 'action', label: 'Action' },
            ],
            mediaFields: [
                { key: 'code', label: 'Media Office Code' },
                { key: 'name', label: 'Media Office Name' },
                { key: 'smiCube', label: 'SMI Cube' },
                { key: 'isExcludeFromReporting', label: 'Exclude from Reporting' },
                { key: 'action', label: 'Action' },
            ],
            editIcon: require("@/assets/Icons/edit.svg"),
            addIcon: require("@/assets/Icons/add.svg"),
        };
    },
    validations: {
        code: {
            required:true
        },
        name: {
            required:true
        },
    },
    mounted() {
        if (this.CanAccessList) {
            this.GetEntities();
            this.GetAllAgencies();
            this.GetAllAccountingOffices();
            this.GetAllMediaOffices();
        } else {
            this.$router.push({
                name: "unauthorized",
                params: {
                    message: "UnAuthorized"
                },
            });
        }
        this.$nextTick(function () {
            window.addEventListener("resize", this.getWindowWidth);
        });
    },
    watch: {
        "AccountingOfficeRequest.AgencyId": function (val) {
            const agency = this.AgencyList.find(item => item.Id === val);
            const entityId = agency?.entityId;
            if(entityId) {
                const entity =  this.EntityData.rows.find(item => item.ID === entityId);
                const entityCode = entity?.Code;
                if(entityCode) {
                    if(!this.IsEdit) {
                        this.AccountingOfficeRequest.Code = null;
                    }
                }
            }
        },
        "AgencyRequest.EntityId": function(val) {
            if(!this.IsEdit) {
                const entity = this.EntityData.rows.find(item => item.ID === val);
                const entityCode = entity?.Code;
                if(entityCode) {
                    this.AgencyRequest.Name = null;
                    this.AgencyRequest.MDMGuid = null;
                    this.AgencyRequest.SMICube = null;
                    this.IsAgencyNameExist = false;
                }
            }
        },
        "MediaOfficeRequest.AccountingOfficeId": function (val) {
            if(!this.IsEdit) {
                const accountingOffice = this.AccountingOfficeList.find(item => item.Id === val);
                const accountingOfficeCode = accountingOffice?.code;
                if(accountingOfficeCode) {
                    this.MediaOfficeRequest.Code = null;
                    this.MediaOfficeRequest.Name = null;
                    this.IsMediaOfficeCodeExist = false;
                }
            }
        },
    },
    computed: {
        ...mapGetters('adminRequest', {
            EntityRequest: 'EntityRequest',
        }),
        ...mapGetters('adminRequest', {
            AgencyRequest: 'AgencyRequest',
        }),
        ...mapGetters('adminRequest', {
            AccountingOfficeRequest: 'AccountingOfficeRequest',
        }),
        ...mapGetters('adminRequest', {
            MediaOfficeRequest: 'MediaOfficeRequest',
        }),
        CanAccessList() {
            return this.$store.getters.canAccessEntityManagementList;
        },
        IsEntityCodeValid() {
            return this.IsValidField(this.EntityRequest.code);
        },
        IsEntityNameValid() {
            return this.IsValidField(this.EntityRequest.name);
        },
        IsEntityFormValid() {
            return this.IsEntityCodeValid && this.IsEntityNameValid;
        },
        IsAgencyEntityValid() {
            return this.IsValidField(this.AgencyRequest.EntityId)
        },
        IsMDMGuidValid() {
            return (
                this.AgencyRequest.MDMGuid &&
                /^[a-zA-Z0-9-]+$/.test(this.AgencyRequest.MDMGuid)
            );
        },
        IsAgencyNameValid() {
            return this.IsValidField(this.AgencyRequest.Name);
        },
        IsAgencyFormValid() {
            return this.IsAgencyEntityValid && this.IsAgencyNameValid && this.IsMDMGuidValid;
        },
        IsAccountingOfficeFormValid() {
            return this.IsValidField(this.AccountingOfficeRequest.AgencyId) &&
                (
                    (this.IsValidField(this.AccountingOfficeRequest.Code) && this.IsValidField(this.AccountingOfficeRequest.Name)) ||
                    (this.IsValidField(this.AccountingOfficeRequest.PrismaNGLocationId) && this.IsValidField(this.AccountingOfficeRequest.PrismaNGLocationName))
                ) &&
                this.IsValidField(this.AccountingOfficeRequest.AXD365Location);
        },
        IsMediaOfficeFormValid() {
            return this.IsValidField(this.MediaOfficeRequest.AccountingOfficeId) &&
                   this.IsValidField(this.MediaOfficeRequest.Code) &&
                   this.IsValidField(this.MediaOfficeRequest.Name) &&
                   (this.IsSMICubePresentForSelectedAccountingOffice() ||
                   (this.MediaOfficeRequest.SMICube && this.MediaOfficeRequest.SMICube.length > 0));
        },
    },
    methods: {
        IsSMICubePresentForSelectedAccountingOffice() {
            const selectedId = this.MediaOfficeRequest.AccountingOfficeId;
            if (!selectedId) return false;
            const office = this.AccountingOfficeList.find(x => x.Id === selectedId);
            return office && office.smiCube && office.smiCube.length > 0;
        },
        CheckAgencyNameExist() {
            this.IsAgencyNameExist = false;
            if (this.AgencyRequest.Name) {
                const existingAgency = this.AgencyList.find(x => x.agency.toLowerCase() === this.AgencyRequest.Name.toLowerCase()
                && x.entityId === this.AgencyRequest.EntityId && x.Id !== this.AgencyRequest.Id);
                if (existingAgency) {
                    this.IsAgencyNameExist = true;
                }
            }
        },
        IsValidField(value) {
            return value != null & value != undefined && value != '';
        },
        CheckMediaOfficeCodeExist() {
            this.IsMediaOfficeCodeExist = false;
            if (this.MediaOfficeRequest.AccountingOfficeId && this.MediaOfficeRequest.Code) {
                const existingMediaOffice = this.MediaOfficeList.find(x => x.accountingOfficeId === this.MediaOfficeRequest.AccountingOfficeId
                                                && x.Id !== this.MediaOfficeRequest.Id
                                                && x.code.toLowerCase() === this.MediaOfficeRequest.Code.toLowerCase());
                if (existingMediaOffice) {
                    this.IsMediaOfficeCodeExist = true;
                }
            }
        },
        GetEntities() {
            this.EntityData.rows = [];
            this.$store
                .dispatch("adminRequest/GetEntities", {})
                .then((res) => {
                    if (res.data) {
                        this.EntityData.rows = res.data.Result;
                    }
                })
                .catch((ex) => {
                    if (ex.response) {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `${ex.response.data}`
                        );
                    } else {
                        this.$store.dispatch(
                            "progress/setErrorMessage",
                            `Error fetching requests.${ex}`
                        );
                    }
                });
        },
        async GetAllAgencies() {
            this.AgencyList = [];
            await this.$store
                .dispatch("adminRequest/GetAllAgencies")
                .then((res) => {
                    if (res.data) {
                        this.AgencyList = res.data.map((agency) => ({
                            entityId: agency.EntityId,
                            Id: agency.ID,
                            agency: agency.Name,
                            mdmGuid: agency.MDMGuid
                        }));
                    }
                })
                .catch((ex) => {
                    console.error("Error fetching agencies:", ex);
                });
        },
        async GetAllAccountingOffices() {
            this.AccountingOfficeList = [];
            await this.$store
                .dispatch("adminRequest/GetAllAccountingOffices")
                .then((res) => {
                    if (res.data) {
                        this.AccountingOfficeList = res.data.map((accountingOffice) => ({
                            agencyId: accountingOffice.AgencyId,
                            Id: accountingOffice.ID,
                            code: accountingOffice.Code,
                            name: accountingOffice.Name,
                            accountingOffice: this.GetAccountingOfficeName(accountingOffice.Code, accountingOffice.Name),
                            prismaNGLocationId: accountingOffice.PrismaNGLocationId,
                            prismaNGLocationName: accountingOffice.PrismaNGLocationName,
                            axD365Location: accountingOffice.AXD365Location,
                            smiCube: accountingOffice.SMICube,
                        }));
                    }
                })
                .catch((ex) => {
                    console.error("Error fetching accounting office:", ex);
                });
        },
        async GetAllMediaOffices() {
            this.MediaOfficeList = [];
            await this.$store
                .dispatch("adminRequest/GetAllMediaOffices")
                .then((res) => {
                    if (res.data) {
                        this.MediaOfficeList = res.data.map((mediaOffice) => ({
                            accountingOfficeId: mediaOffice.AccountingOfficeId,
                            Id: mediaOffice.ID,
                            code: mediaOffice.Code,
                            name: mediaOffice.Name,
                            mediaOffice: `${mediaOffice.Code} - ${mediaOffice.Name}`,
                            smiCube: mediaOffice.SMICube,
                            isExcludeFromReporting: mediaOffice.IsExcludeFromReporting ?? false,
                        }));
                    }
                })
                .catch((ex) => {
                    console.error("Error fetching media office:", ex);
                });
        },
        GetAccountingOfficeName(code, name){
            if(code && name){
                return `${code} - ${name}`;
            } else if(code){
                return code;
            } else if(name){
                return name;
            } else{
                return '';
            }
        },
        async GetAllEntitiesForAgency() {
            this.EntitiesForAgency = this.EntityData.rows.map(entity => ({
                Code: entity.Code,
                Name: entity.Name,
                label: `${entity.Code} - ${entity.Name}`,
                value: entity.ID,
            }));
        },
        async GetAllAgenciesForAccountingOffice() {
            this.AgenciesForAccountingOffice = this.AgencyList.map(agency => ({
                ID: agency.Id,
                Name: agency.agency,
                label: agency.agency,
                value: agency.Id
            }));
        },
        async GetAllAccountingOfficeForMediaOffice() {
            this.AccountingOfficeForMediaOffice = this.AccountingOfficeList
                .filter(accOffice => accOffice.code && accOffice.name)
                .map(accountingOffice => ({
                    label: `${accountingOffice.code} - ${accountingOffice.name}`,
                    value: accountingOffice.Id
                }));
        },
        PrepareEntityFormData() {
            let adminRequestData = Object.assign({}, this.EntityRequest);
            adminRequestData.isTimeOnly = this.EntityRequest.isTimeOnly == true ? true : false;
            return adminRequestData;
        },
        SubmitEntityForm() {
            let data = this.PrepareEntityFormData();
            this.$store
                .dispatch("adminRequest/AddEntity", data)
                .then(() => {
                    this.GetEntities();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Entity has been added successfully!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while adding Entity"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        SubmitAgencyForm() {
            let data = this.AgencyRequest;
            this.$store
                .dispatch("adminRequest/AddAgency", data)
                .then(() => {
                    this.GetAllAgencies();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Agency has been added successfully!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while adding Agency"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        SubmitAccountingOfficeForm(){
            let data = this.AccountingOfficeRequest;
            this.$store
                .dispatch("adminRequest/AddAccountingOffice", data)
                .then(() => {
                    this.GetAllAccountingOffices();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Accounting Office has been added successfully!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while adding Accounting office"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        SubmitMediaOfficeForm(){
            let data = this.MediaOfficeRequest;
            this.$store
                .dispatch("adminRequest/AddMediaOffice", data)
                .then(() => {
                    this.GetAllMediaOffices();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Media Office has been added successfully!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while adding Media office"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        UpdateEntityFormData() {
            let adminRequestData = Object.assign({}, this.EntityRequest);
            adminRequestData.isTimeOnly = this.EntityRequest.isTimeOnly == true ? true : false;
            return adminRequestData;
        },
        UpdateEntityForm() {
            let updateData = this.UpdateEntityFormData();
            this.$store
                .dispatch("adminRequest/UpdateEntity",  {
                    id: this.EntityId,
                    data: updateData
                })
                .then(() => {
                    this.GetEntities();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Entity has been updated!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while updating Entity"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        UpdateAgencyForm() {
            let updateData = Object.assign({}, this.AgencyRequest);
            updateData.ID = this.AgencyRequest.Id;
            this.$store
                .dispatch("adminRequest/UpdateAgency", {
                    id: parseInt(this.AgencyRequest.Id),
                    data: updateData
                })
                .then(() => {
                    this.GetAllAgencies();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Agency has been updated!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while updating Agency"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        UpdateAccountingOfficeForm() {
            let updateData = Object.assign({}, this.AccountingOfficeRequest);
            updateData.ID = this.AccountingOfficeRequest.Id;
            this.$store
                .dispatch("adminRequest/UpdateAccountingOffice", {
                    id: parseInt(this.AccountingOfficeRequest.Id),
                    data: updateData
                })
                .then(() => {
                    this.GetAllAccountingOffices();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Accounting Office has been updated!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while updating Accounting Office"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        UpdateMediaOfficeForm() {
            let updateData = Object.assign({}, this.MediaOfficeRequest);
            updateData.ID = this.MediaOfficeRequest.Id;
            this.$store
                .dispatch("adminRequest/UpdateMediaOffice", {
                    id: parseInt(this.MediaOfficeRequest.Id),
                    data: updateData
                })
                .then(() => {
                    this.GetAllMediaOffices();
                    this.$router.push("/Admin");
                    store.dispatch(
                        "progress/setSuccessMessage",
                        "Media Office has been updated!"
                    );
                })
                .catch((ex) => {
                     if (ex.response && [400, 403].includes(ex.response.status)) {
                        store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                    }
                    else {
                    window.console.log(JSON.stringify(ex));
                        store.dispatch(
                            "progress/setErrorMessage",
                            "Error while updating Media Office"
                        );
                    }
                });
                this.HidePopUpForm();
        },
        async getAllAgencies(entityId, showDetails) {
            if(showDetails) {
                await this.GetEntityAgencies(entityId);
            }
        },
        getAgencies(entityId) {
            return this.AgencyList.filter(a => a.entityId === entityId);
        },
        getAccountingOffices(agencyId) {
            return this.AccountingOfficeList.filter(a => a.agencyId === agencyId);
        },
        getMediaOffices(accountingOfficeId) {
            return this.MediaOfficeList.filter(m => m.accountingOfficeId === accountingOfficeId);
        },
        ResetEntityForm() {
            this.EntityRequest.code = null;
            this.EntityRequest.name = null;
            this.EntityRequest.isTimeOnly = null;
        },
        ResetAgencyForm() {
            this.IsAgencyNameExist = false,
            this.AgencyRequest.EntityId = null;
            this.AgencyRequest.Id = 0;
            this.AgencyRequest.Name = null;
            this.AgencyRequest.MDMGuid = "";
        },
        ResetAccountingOfficeForm() {
            this.AccountingOfficeRequest.Id = 0;
            this.AccountingOfficeRequest.AgencyId = null;
            this.AccountingOfficeRequest.Code = null;
            this.AccountingOfficeRequest.Name = null;
            this.AccountingOfficeRequest.PrismaNGLocationId = null;
            this.AccountingOfficeRequest.PrismaNGLocationName = null;
            this.AccountingOfficeRequest.AXD365Location = null;
            this.AccountingOfficeRequest.SMICube = null;
        },
        ResetMediaOfficeForm() {
            this.IsMediaOfficeCodeExist = false;
            this.MediaOfficeRequest.AccountingOfficeId = null;
            this.MediaOfficeRequest.Code = null;
            this.MediaOfficeRequest.Name = null;
            this.MediaOfficeRequest.Id = 0;
            this.MediaOfficeRequest.SMICube = null;
            this.MediaOfficeRequest.IsExcludeFromReporting = false;
        },
        async ShowPopUpForm(val, id) {
            if (val === 'Entity') {
                this.ShowEntityForm = true;
            } else if (val === 'Agency') {
                this.GetAllEntitiesForAgency();
                this.ShowAgencyForm = true;
                if(id) {
                    this.AgencyRequest.EntityId = id;
                }
            } else if (val === 'AccountingOffice') {
                this.GetAllAgenciesForAccountingOffice();
                this.ShowAccountingOfficeForm = true;
                if(id) {
                    this.AccountingOfficeRequest.AgencyId = id;
                }
            } else if (val === 'MediaOffice') {
                this.GetAllAccountingOfficeForMediaOffice();
                this.ShowMediaOfficeForm = true;
                if(id) {
                    this.MediaOfficeRequest.AccountingOfficeId = id;
                }
            }
        },
        HidePopUpForm() {
            this.ShowEntityForm = false;
            this.ShowAgencyForm = false;
            this.ShowAccountingOfficeForm = false;
            this.ShowMediaOfficeForm = false;
            this.IsEdit = false;
            this.ResetEntityForm()
            this.ResetAgencyForm()
            this.ResetAccountingOfficeForm();
            this.ResetMediaOfficeForm();
        },
        async EditEntity(row) {
            this.IsEdit = true;
            this.EntityId = parseInt(row.ID);
            this.EntityRequest.code = row.Code;
            this.EntityRequest.name = row.Name;
            this.EntityRequest.isTimeOnly = row.IsTimeOnly;
            this.ShowEntityForm = true;
        },
        EditAgency(agency) {
            this.IsEdit = true;
            this.GetAllEntitiesForAgency();
            this.AgencyRequest.EntityId = agency.entityId;
            this.AgencyRequest.Id = agency.Id;
            this.AgencyRequest.Name = agency.agency;
            this.AgencyRequest.MDMGuid = agency.mdmGuid;
            this.ShowAgencyForm = true;
        },
        async EditAccountingOffice(accountingOffice) {
            this.IsEdit = true;
            this.GetAllAgenciesForAccountingOffice();
            this.AccountingOfficeRequest.Id = accountingOffice.Id;
            this.AccountingOfficeRequest.AgencyId = accountingOffice.agencyId;
            this.AccountingOfficeRequest.Code = accountingOffice.code;
            this.AccountingOfficeRequest.Name = accountingOffice.name;
            this.AccountingOfficeRequest.PrismaNGLocationId = accountingOffice.prismaNGLocationId;
            this.AccountingOfficeRequest.PrismaNGLocationName = accountingOffice.prismaNGLocationName;
            this.AccountingOfficeRequest.AXD365Location = accountingOffice.axD365Location;
            this.AccountingOfficeRequest.SMICube = accountingOffice.smiCube;
            this.ShowAccountingOfficeForm = true;
        },
        EditMediaOffice(mediaOffice) {
            this.IsEdit = true;
            this.GetAllAccountingOfficeForMediaOffice();
            this.MediaOfficeRequest.Id = mediaOffice.Id;
            this.MediaOfficeRequest.AccountingOfficeId = mediaOffice.accountingOfficeId;
            this.MediaOfficeRequest.Code = mediaOffice.code;
            this.MediaOfficeRequest.Name = mediaOffice.name;
            this.MediaOfficeRequest.SMICube = mediaOffice.smiCube;
            this.MediaOfficeRequest.IsExcludeFromReporting = mediaOffice.isExcludeFromReporting ?? false;
            this.ShowMediaOfficeForm = true;
        },
    },
};
</script>
<style>
    .add-button {
        transform: scale(1.5);
    }
    .icon-container {
        display: flex;
        width: 20px;
        height: 7.5px;
        justify-content: center;
        align-items: center;
    }
    .common-table .entity-table .table thead th {
        padding-left:15px !important;
    }
    .common-table .entity-table table tbody tr td {
        padding: 7.5px 15px !important;
    }
    .edit-icon {
        width: 15px;
    }
    .common-table .table-responsive .table thead th {
        color: #ffffff !important;
        background-color: #2a2f43 !important;
    }
    .common-table .table-responsive .agencies-table thead th {
        background-color: #373d55 !important;
    }
    .common-table .table-responsive .agencies-table table.table {
        width: calc(100% - 120px);
        margin: 10px 60px;
    }
    .common-table .table-responsive .agencies-table table.table tbody tr:nth-of-type(odd) {
        background-color: #f4f4f4 !important;
    }
    .common-table .table-responsive .accounting-Office-table thead th {
        background-color: #484f6a !important;
    }

    .common-table .table-responsive .media-Office-table thead th {
        background-color: #565e7e !important;
    }
    .media-Office-table tr td, .media-Office-table tr th {
        padding-left: 15px !important;
    }

    .expand-collapse-button {
        font-size: 1.7rem;
        color: #00a1d2;
        font-weight: bold;
    }
    .expand-collapse-button:hover {
        cursor: pointer;
        text-decoration: none;
    }
</style>